<template>
  <div class="big">
    <div class="container">
      <div
        class="flex_between"
        style="margin-bottom:20px"
      >
        <span>
          <span class="itemtitle">模板名称</span>
          <el-input
            v-model="tmp_name"
            style="width:120px;margin:0 15px 0 8px"
            @change="search"
          ></el-input>
          <el-button
            type="info"
            style="background-color: #eceff2; color: #747981"
            @click="search"
          >查询</el-button>
        </span>
        <el-button
          type="primary"
          icon="el-icon-plus"
          :disabled="
                    module_id_array[0]
                      ? !module_id_array.includes('985')
                      : false
                  "
          @click="AddTemDia"
        >新增省市模板</el-button>
      </div>
      <div style="border: solid 1px #c9cbd6;">
        <el-table
          ref="multipleTable"
          :data="tableData"
          tooltip-effect="dark"
          style="width: 100%;min-width:1000px;"
          :header-cell-style="{background:'#F5F5F5'}"
        >
          <el-table-column
            prop="province_city_name"
            label="省市地区"
          ></el-table-column>
          <el-table-column
            prop="tmp_name"
            label="模板名称"
          ></el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button
                type="text"
                @click="editTemDia(scope.row.area_id)"
                :disabled="
                    module_id_array[0]
                      ? !module_id_array.includes('986')
                      : false
                  "
              >编辑</el-button>
              <el-button
                type="text"
                @click="delArea(scope.row.area_id)"
                :disabled="
                    module_id_array[0]
                      ? !module_id_array.includes('987')
                      : false
                  "
              >删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div>
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pagesize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalNum"
          style="margin:20px 0"
        ></el-pagination>
      </div>
    </div>
    <!-- 编辑模板弹窗 -->
    <el-dialog
      :title="title"
      :visible.sync="editTem"
      width="600px"
      :close-on-click-modal="false"
    >
      <div class="dialogbox">
        <div class="align-center">
          <div style="width: 120px; text-align: right">模板配置的地区：</div>
          <el-input
            v-model="province_city_name"
            type="textarea"
            :autosize="{ minRows: 2, maxRows: 10 }"
            style="width: 300px"
          ></el-input>
          <el-button
            type="text"
            style="margin-left: 10px"
            @click="showArea"
          >选择地区</el-button>
        </div>
        <div
          class="align-center"
          style="margin-top: 16px"
        >
          <div style="width: 120px; text-align: right">选择模板：</div>
          <el-select
            v-model="tmp_id"
            placeholder="请选择"
            style="width: 300px"
          >
            <el-option
              v-for="item in temList"
              :key="item.value"
              :label="item.tmp_name"
              :value="item.tmp_id"
            ></el-option>
          </el-select>
        </div>
      </div>
      <el-dialog
        width="700px"
        title="选择地区"
        :visible.sync="address"
        append-to-body
      >
        <div style="padding-bottom: 20px">
          <div class="areabox">
            <div class="areaitem">
              <div>
                <div
                  v-for="(pro, index) in areaData"
                  :key="index"
                  class="provinceitem"
                >
                  <span
                    @click="choosePro(pro, index)"
                    :style="{ color: pro.isChecked ? '#1890ff' : '#333' }"
                  >{{ pro.name }}</span>

                  <span
                    v-for="(city, ind) in pro.city"
                    :key="ind"
                    :style="{ color: city.isChecked ? '#1890ff' : '#999' }"
                    @click="chooseCity(city, pro, index, ind)"
                  >{{ city.name }}</span>
                </div>
              </div>
            </div>
          </div>
          <div
            slot="footer"
            class="dialog-footer"
            style="text-align: center; margin-top: 20px"
          >
            <el-button
              plain
              @click="address = false"
              style="width: 100px"
            >取消</el-button>
            <el-button
              type="primary"
              @click="chooseAdd"
              style="width: 100px"
            >确定</el-button>
          </div>
        </div>
      </el-dialog>
      <div style="text-align: left; padding: 0 0 20px 140px">
        <span
          slot="footer"
          class="dialog-footer"
        >
          <el-button
            type="primary"
            @click="submit"
            style="width: 70px"
            size="small"
          >保 存</el-button>
        </span>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  data() {
    return {
      currentPage: 1,
      pagesize: 10,
      totalNum: 0,
      tableData: [],
      tmp_name: '',
      areaData: [],
      editTem: false,
      address: false,
      title: '添加省市模板',
      temList: [],
      totalDoc: 0,
      tmp_id: '', //选择的模板id
      check_id: '',
      provinces_id: '',
      cities_id: '',
      province_city_name: '',
      area_id: ''
    };
  },
  computed: {
    module_id_array() {
      return this.$store.state.userInfo.userInfo.module_id_array;
    }
  },
  methods: {
    //获取列表
    getList() {
      let data = {
        page: this.currentPage,
        pageNumber: this.pagesize,
        tmp_name: this.tmp_name,
        is_special_tmp: 0
      };
      this.axios
        .post('platform/Drugtype/getDrugTypeTemplateAreaConfigList', data)
        .then((res) => {
          if (res.code == 0) {
            if (!res.data.list.length && this.currentPage > 1) {
              this.currentPage = this.currentPage - 1;
              this.getList();
            }
            this.tableData = res.data.list;
            this.totalNum = res.data.total;
          }
        });
    },
    //获取省份-城市
    getAreaList() {
      this.axios
        .post('platform/platform/getProvinceCityDistrict')
        .then((res) => {
          let areaData = [];
          areaData = res.data.list;
          areaData.forEach((item) => {
            item.isChecked = false;
            item.city.forEach((city) => {
              city.isChecked = false;
            });
          });
          this.areaData = areaData;
        });
    },
    //搜索
    search() {
      this.currentPage = 1;
      this.getList();
    },
    //每页数据的条数
    handleSizeChange(size) {
      this.pagesize = size;
      this.getList();
    },
    //当前第几页
    handleCurrentChange(currentPage) {
      this.currentPage = currentPage;
      this.getList();
    },
    //模板列表
    getTemList() {
      this.axios
        .post('platform/Drugtype/getDrugTypeTemplateLists')
        .then((res) => {
          if (res.code == 0) {
            this.temList = res.data.list.map((item) => {
              item.check = false;
              return item;
            });
          }
        });
    },
    //添加模板弹窗
    AddTemDia() {
      this.title = '添加省市模板';
      this.tmp_id = '';
      this.provinces_id = '';
      this.cities_id = '';
      this.province_city_name = '';
      this.area_id = 0;
      this.editTem = true;
    },
    //编辑模板弹窗
    editTemDia(area_id) {
      this.area_id = area_id;
      this.title = '编辑省市模板';
      this.axios
        .post('platform/Drugtype/getDrugTypeTemplateAreaConfigInfo', {
          area_id
        })
        .then((res) => {
          if (res.code == 0) {
            let info = res.data.info;
            this.tmp_id = info.tmp_id;
            this.provinces_id = info.provinces_id;
            this.cities_id = info.cities_id;
            this.province_city_name = info.province_city_name;
          }
        });
      this.editTem = true;
    },
    //编辑地区弹窗
    showArea() {
      let pro_id = [];
      let city_id = [];
      if (!this.provinces_id && !this.cities_id) {
        pro_id = [];
        city_id = [];
      } else {
        pro_id = this.provinces_id.split(',');
        city_id = this.cities_id.split(',');
      }
      this.areaData.forEach((item) => {
        item.isChecked = false;
        let a = 0;
        item.name = item.name.replace(/\([^\)]*\)/g, '');
        if (pro_id.includes(item.province_id + '')) {
          item.isChecked = true;
          a = 1;
        }
        item.city.forEach((city) => {
          city.isChecked = false;
          if (city_id.includes(city.city_id + '')) {
            city.isChecked = true;
          }
        });
        if (a) {
          item.isChecked = true;
        }
      });
      this.address = true;
    },
    //选择省
    choosePro(pro, index) {
      pro.isChecked = !pro.isChecked;
      pro.city.forEach((ele) => {
        ele.isChecked = pro.isChecked;
      });
    },
    //选择市
    chooseCity(city, pro, index, ind) {
      pro.isChecked = false;
      city.isChecked = !city.isChecked;
      this.areaData[index].city.forEach((i) => {
        let a = 0;
        if (i.isChecked) {
          a = 1;
        }
        if (a) {
          pro.isChecked = true;
        }
      });
    },
    //选择的地区
    chooseAdd() {
      let proData = [];
      let cityData = [];
      this.areaData.map((pro) => {
        if (pro.isChecked) {
          let a = 0;
          let city_name = '';
          pro.city.map((city) => {
            if (!city.isChecked) {
              a = 1;
            } else {
              city_name += city.name + ',';
            }
          });
          if (a) {
            pro.name =
              pro.name + '(' + city_name.substr(0, city_name.length - 1) + ')';
          }
          proData.push(pro);
        }
        pro.city.map((city) => {
          if (city.isChecked) {
            cityData.push(city);
          }
        });
      });
      let pro_id = [];
      let city_id = [];
      let pros = [];
      pros = proData.map((item) => {
        return item.name;
      });
      pro_id = proData.map((item) => {
        return item.province_id;
      });
      city_id = cityData.map((item) => {
        if (item.isChecked) {
          return item.city_id;
        }
      });
      this.provinces_id = pro_id.toString();
      this.cities_id = city_id.toString();
      this.province_city_name = pros.toString();
      this.address = false;
    },
    //保存
    submit() {
      if (!this.tmp_id || !this.province_city_name) {
        this.$message.error('请选择区域和模板');
        return false;
      }
      let data = {
        provinces_id: this.provinces_id,
        cities_id: this.cities_id,
        province_city_name: this.province_city_name,
        tmp_id: this.tmp_id
      };
      if (this.title == '添加省市模板') {
        this.axios
          .post('platform/Drugtype/addDrugTypeTemplateAreaConfigInfo', data)
          .then((res) => {
            if (res.code == 0) {
              this.$message.success('添加成功');
              this.editTem = false;
              this.getList();
            }
          });
      } else {
        data.area_id = this.area_id;
        this.axios
          .post('platform/Drugtype/editDrugTypeTemplateAreaConfigInfo', data)
          .then((res) => {
            if (res.code == 0) {
              this.$message.success('操作成功');
              this.editTem = false;
              this.getList();
            }
          });
      }
    },
    //关闭弹窗
    closeDia() {
      this.editTem = false;
      this.getList();
    },
    //删除
    delArea(area_id) {
      this.$confirm('确定要删除该模板吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      })
        .then(() => {
          this.axios
            .post('platform/Drugtype/deleteDrugTypeTemplateAreaConfigInfo', {
              area_id
            })
            .then((res) => {
              if (res.code == 0) {
                this.$message.success('已删除该模板');
                this.getList();
              }
            });
        })
        .catch(() => {});
    },
    back() {
      history.back();
    }
  },
  created() {
    this.getList();
    this.getAreaList();
    this.getTemList();
  }
};
</script>
<style lang="scss" scoped>
.container {
  box-sizing: border-box;
  background-color: #ffffff;
  min-height: calc(100vh - 237px);
  text-align: center;
}
.dialogbox {
  box-sizing: border-box;
  padding: 20px;
  text-align: left;
}
.areabox {
  width: 668px;
  height: 446px;
  border: solid 1px #c9cbd6;
  border-bottom: 0px solid #e8e9f0;
  margin: 0 auto;
  margin-top: 20px;
  overflow-y: scroll;
  box-sizing: border-box;
  .areaitem {
    .provinceitem {
      padding: 5px;
      line-height: 30px;
      border-bottom: 1px solid #e8e9f0;
      box-sizing: border-box;

      div {
        margin: 10px 0;
        width: 550px;
      }
      span {
        margin-right: 15px;
        display: inline-block;
        margin-bottom: 5px;
        color: #999;
        cursor: pointer;
      }
      span:first-child {
        color: #333;
        padding-right: 10px;
        border-right: 2px solid #e8e9f0;
        margin-bottom: 5px;
      }
    }
  }
}
</style>
